// Hausa translations
export const ha: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Abokan ciniki',
  'menu.products': 'Kayayyaki',
  'menu.users': 'Masu amfani',
  'menu.settings': 'Saitunan',
  'menu.logout': 'Fita',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Sabon Oda',
  'order.title': 'Sabon Oda',
  'order.customer': 'Abokin ciniki',
  'order.products': 'Kayayyaki',
  'order.total': 'Jimla',
  'users.title': 'Masu amfani',
  'users.name': 'Suna',
  'users.email': 'Imel',
  'common.yes': 'E',
  'common.no': "A'a",
  'common.cancel': 'Soke',
  'common.save': 'Ajiye',
  'common.search': 'Bincika',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Shiga',
  'login.welcome': 'Barka da zuwa, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imel',
  'signup.phone': 'Waya',
  'menu.reportsAndAccounting': 'Rahotanni da Lissafi',
  'menu.systemAndCommunication': 'Tsari da Sadarwa',
};